/* Its own module, free of React, so the form engine resolves a field's state
 * the same way by deep import, without the barrel (form-engine.md). */

/**
 * The state a field renders, resolved once for every control (field.md).
 * Read-only outranks the rest: a value the reader cannot change shows no
 * required mark, no disabled wash and no error they could not act on. The
 * field is invalid exactly when it shows an error.
 */
export function resolveFieldState({
  isDisabled = false,
  isReadOnly = false,
  isRequired = false,
  error,
}: {
  isDisabled?: boolean;
  isReadOnly?: boolean;
  isRequired?: boolean;
  error?: string;
}) {
  if (isReadOnly) {
    return {
      isDisabled: false,
      isReadOnly: true,
      isRequired: false,
      isInvalid: false,
      error: undefined,
    };
  }
  return {
    isDisabled,
    isReadOnly: false,
    isRequired,
    isInvalid: !isDisabled && !!error,
    error: isDisabled ? undefined : error || undefined,
  };
}
